import React from 'react';
import { useEffect, useRef, useState } from 'react';
import { Button, message, Tabs, List, Checkbox, Radio, Spin, Popover, TreeSelect } from 'antd';
import { PlusOutlined, UnorderedListOutlined, EyeOutlined, EyeInvisibleOutlined } from '@ant-design/icons';
import {
  getTrackPlanPage,
  getCustomerMemberInfo,
  getTrackPlanInfo,
  getTrackDetailCount,
  getTabPageCount,
  getTrackPlanLog,
  getTrackPlanRelatives,
  viewPhone,
  getDrawTags,
  getTrackPlanNode,
  getTagTreeByType,
  getButtonList,
  getButtonByTemplateId,
  getCustomerSource,
  getHouseNatureEnum,
  getTrackPlanStatusEnum,
} from "@/services/customerServices.ts";
import { getRealEstateList } from '@/services/homeService';
import { getAdvertWorkerList } from '@/services/getUsers';
import { findOrgTree } from '@/services/externalPerson';
import {
  SMessage,
  SSearchForm,
  STitle,
} from 'shj-components';
import dayjs from 'dayjs';
import { authDict } from 'shj-utils';
import { config } from '@/pages/crm/sellPlan/config';
import BasicInfo from '@/components/BasicInfo';
import FollowRecord from '@/components/FollowRecord';
import ServiorInfo from '@/components/ServiorInfo';
import WorkProcess from './components/WorkProcess';
import OrderInfo from '@/components/OrderInfo';
import OperationBoard from './components/OperationBoard';
import AddNewPlanModal from '@/components/AddNewPlanModal';
import CustomerModal from '@/components/EditBasicInfoModal';
import ChooseTagModal from '@/components/ChooseTagModal';
import AllowcateWorkerModal from '@/components/AllowcateWorkerModal';
import avatarNew from '@/assets/avatar-new.png';
import AddNewFollowModal from './components/AddNewFollowModal';
import SubmitPendingModal from './components/SubmitPendingModal';
import SubmitEffectiveModal from './components/SubmitEffectiveModal';
import SubscribeModal from './components/SubscribeModal';
import ConfirmModal from './components/ConfirmModal';
import CustomerDetail from './components/CustomerDetail';
import SubmitInvalidModal from './components/SubmitInvalidModal';
import styles from './index.module.less';
import { useSetState } from 'ahooks';
import ChangeDeliveryTimeModal from "@/pages/crm/sellPlan/components/ChangeDeliveryTimeModal";
import DelayReassignModal from "@/pages/crm/sellPlan/components/DelayReassignModal";
import ProposalMasterModal from "@/pages/crm/sellPlan/components/ProposalMasterModal";
import DesignMasterModal from "@/pages/crm/sellPlan/components/DesignMasterModal";

const colorList = [{
  borderColor: 'rgba(250, 96, 80, 1)',
  fontColor: 'rgba(242, 90, 10, 1)',
}, {
  borderColor: 'rgba(0, 100, 255, 1)',
  fontColor: 'rgba(0, 100, 255, 1)',
}, {
  borderColor: 'rgba(245, 147, 0, 1)',
  fontColor: 'rgba(245, 147, 0, 1)',
}, {
  borderColor: 'rgba(112, 163, 16, 1)',
  fontColor: 'rgba(112, 163, 16, 1)',
}]

export default function SellPlan ()  {
  const listRef = useRef()
  const [openAddModal, setOpenAddModal] = useState(false);
  const [openChooseTagModal, setOpenChooseTagModal] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [openCustomerModal, setOpenCustomerModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [totalNumber, setTotalNumber] = useState(1);
  const [pageId, setPageId] = useState(1);
  const [searchData, setSearchData] = useState({});
  const [userData, setUserData] = useState([])
  const [infoChoice, setInfoChoice] = useState('a')
  const [chooseCustomerId, setChooseCustomerId] = useState('');
  const [chooseTrackPlanId, setChooseTrackPlanId] = useState('');
  const [customerInfo, setCustomerInfo] = useState({
    customerInfo: {},
    memberInfo: {},
  });
  const [salesTemplateId, setSalesTemplateId] = useState('');
  const [trackPlanNodeData, setTrackPlanNodeData] = useState([]);
  const [tagList, setTagList] = useState<Array<any>>([]);
  const [drawTagListMap, setDrawTagListMap] = useState({});
  const [trackPlanLogInfo, setTrackPlanLogInfo] = useState([]);
  const [trackPlanReletiveInfo, setTrackPlanReletiveInfo] = useState([]);
  const [detailCountData, setDetailCountData] = useState({});
  const [tabCountData, setTabCountData] = useState({});
  const [trackPlanInfo, setTrackPlanInfo] = useState({});
  const [tabsChoose, setTabsChoose] = useState('1');
  const [openNewFollowModal, setOpenNewFollowModal] = useState(false);
  const [openSubmitPendingModal, setOpenSubmitPendingModal] = useState(false);
  const [openSubmitEffectiveModal, setOpenSubmitEffectiveModal] = useState(false);
  const [openCustomerDetail, setOpenCustomerDetail] = useState(false);
  const [openSubscribeModal, setOpenSubscribeModal] = useState(false);
  const [openConfirmModal, setOpenConfirmModal] = useState(false);
  const [openSubmitInvalidModal, setOpenSubmitInvalidModal] = useState(false);
  const [openAllowcateModal, setOpenAllowcateModal] = useState(false);
  const [openChangeDeliveryTimeModal, setOpenChangeDeliveryTimeModal] = useState(false);
  const [openDelayReassignModal, setOpenDelayReassignModal] = useState(false);
  const [openProposalMasterModal, setOpenProposalMasterModal] = useState(false);
  const [openDesignMasterModal, setOpenDesignMasterModal] = useState(false);
  const [extraPopoverOpen, setExtraPopoverOpen] = useState(false);
  const [mainButtonList, setMainButtonList] = useState([]);
  const [extraButtonList, setExtraButtonList] = useState([]);
  const [chooseButtonKey, setChooseButtonKey] = useState('');
  const [dictionaryData, setDictionaryData] = useSetState({
    customerOrigin: [],
    buildOptions: [],
    treeList: [],
    personList: [],
    houseNatureCode: [],
    trackPlanCode: []
  })

  useEffect(() => {
    fetchTabCount();
    fetchTagTreeByType();
    fetchDictionaryData();
  }, []);

  // 销售计划详情，客户信息
  useEffect(() => {
    if (chooseCustomerId) {
      fetchCustomerMemberInfo(chooseCustomerId);
    }
    if (chooseTrackPlanId) {
      fetchTrackPlanInfo(chooseTrackPlanId);
      fetchTrackDetailCount(chooseTrackPlanId);
      fetchTrackPlanLog(chooseTrackPlanId);
      fetchTrackPlanRelatives(chooseTrackPlanId);
      fetchDrawTags(chooseTrackPlanId);
      fetchTrackPlanNode(chooseTrackPlanId);
      fetchButtonList(chooseTrackPlanId);
    }
  }, [chooseCustomerId, chooseTrackPlanId, salesTemplateId]);

  // 客户列表
  useEffect(() => {
    if (pageId && searchData && tabsChoose) {
      fetchList({ pageId, values: searchData }); 
    }
  }, [pageId, searchData, tabsChoose]);

  const fetchDictionaryData = async () => {
    try {
      const originRes: any = await getCustomerSource();
      if (originRes instanceof Array) {
        setDictionaryData({ customerOrigin: originRes });
      }
      const buildingList = await getRealEstateList();
      if (buildingList instanceof Array) {
        const options = buildingList?.map(build => ({
          value: build.id,
          label: build.name
        }));
        setDictionaryData({ buildOptions: options });
      }
      const treeList = await findOrgTree({});
      if (treeList instanceof Array) {
        setDictionaryData({ treeList });
      }
      // const personList = await getAdvertWorkerList({})
      const resList: any = await Promise.allSettled([
        getHouseNatureEnum(),
        getTrackPlanStatusEnum(),
      ]);
      const houseNatureCode = resList?.[0]?.value instanceof Array ? resList?.[0]?.value : [];
      const trackPlanCode = resList?.[1]?.value instanceof Array ? resList?.[1]?.value : [];
      setDictionaryData({ houseNatureCode, trackPlanCode });
    } catch (err) {
      console.log(err)
    }
  }

  const handleOrgChange = async (value: any) => {
    if (!value) {
      return;
    }
    const personList = await getAdvertWorkerList({
      userIdentityFilter: {
        orgId: value,
      }
    })
    setDictionaryData({ personList });
  }

  // 按钮列表
  const fetchButtonList = async (trackPlanId: any) => {
    const mainButtonKeyList = ['ADD_RECORD', 'SUBMIT_PENDING', 'SUBMIT_VALID', 'SUBMIT_INVALID', 'APPOINTMENT_STORE', 'CONFIRM_TO_SHOP'];
    try {
      let res: any = {};
      if (tabsChoose !== '5') {
        res = await getButtonList(trackPlanId);
      } else {
        res = await getButtonByTemplateId(salesTemplateId);
      }
      if (res instanceof Array) {
        const mainList: any = res.filter(item => mainButtonKeyList.includes(item?.buttonKey));
        const extraList: any = res.filter(item => !mainButtonKeyList.includes(item?.buttonKey));
        const addExtraBtn = [
            {buttonKey: 'CHANGE_TIME', buttonDesc: '变更交房时间'},
            {buttonKey: 'DELAY', buttonDesc: '延期改派'},
            {buttonKey: 'GO_CASE', buttonDesc: '去提案大师'},
            {buttonKey: 'GO_DESIGNER', buttonDesc: '去设计大师'},
        ]
        const extraButtonList = extraList.concat(addExtraBtn)
        setMainButtonList(mainList);
        setExtraButtonList(extraButtonList);
      }
    } catch (err) {
      console.log(err)
    }
  }

  const getPath = (treeNode, virtualList, trueList, id) => {
    virtualList.push(treeNode?.id);
    if (treeNode?.id === id) {
      virtualList?.forEach(item => trueList.push(item))
      return;
    }
    if (treeNode?.children?.length) {
      treeNode?.children?.forEach(node => {
        getPath(node, virtualList, trueList, id);
      })
    }
  }

  // 客户列表
  const fetchList = async ({ pageId = 1, values }, noAutoChoose = false) => {
    try {
      const extraParam = {
        recentDispatchFlag: tabsChoose === '2' ? true : false,
        recentFollowFlag: tabsChoose === '3' ? true : false,
        pendingDispatchFlag: tabsChoose === '4' ? true : false,
      }
      setLoading(true);
      let relativesRequest = {
        ucenterUserId: 0,
        dutyType: ''
      }
      if (values?.salesman) {
        relativesRequest = {
          ucenterUserId: values?.salesman,
          dutyType: 'subsidiary.salesman'
        }
      }
      if (values?.designer) {
        relativesRequest = {
          ucenterUserId: values?.designer,
          dutyType: 'subsidiary.designer'
        }
      }
      if (values?.softDesign) {
        relativesRequest = {
          ucenterUserId: values?.softDesign,
          dutyType: 'subsidiary.softDesign'
        }
      }
      if (values?.tailorMadeDesign) {
        relativesRequest = {
          ucenterUserId: values?.tailorMadeDesign,
          dutyType: 'subsidiary.tailorMadeDesign'
        }
      }
      const deptIds = []
      if (values?.treeOrg) {
        dictionaryData?.treeList?.forEach(node => {
          getPath(node, [], deptIds, values?.treeOrg)
        })
      }
      const newValue: any = values ? {
        ...values,
        nameLike: values.name,
        channelId: values.channelId?.[values?.channelId?.length - 1] || '',
        createdTimeStartWith: values.createdTime ? dayjs(values.createdTime?.[0]).format('YYYY-MM-DD HH:mm:ss') : '',
        createdTimeEndWith: values.createdTime ? dayjs(values.createdTime?.[1]).format('YYYY-MM-DD HH:mm:ss'): '',
        lastUpdatedTimeStartWith: values.lastUpdatedTime ? dayjs(values.lastUpdatedTime?.[0]).format('YYYY-MM-DD HH:mm:ss') : '',
        lastUpdatedTimeEndWith: values.lastUpdatedTime ? dayjs(values.lastUpdatedTime?.[1]).format('YYYY-MM-DD HH:mm:ss') : '',
      } : {};
      if (relativesRequest.ucenterUserId) {
        newValue['relativesRequest'] = relativesRequest;
      }
      if (deptIds?.length) {
        newValue['deptIds'] = deptIds;
      }
      delete newValue.name;
      delete newValue.createdTime;
      delete newValue.lastUpdatedTime;
      const res: any = await getTrackPlanPage({
        params: { pageId, pageSize: 10 },
        data: { ...newValue, trackPlanDtlFlag: true, ...extraParam }
      });
      setLoading(false);
      setTotalNumber(Number(res?.count || 1))
      if (res?.list && !noAutoChoose) {
        if (res?.list?.[0]) {
          res.list[0].choose = true; // 默认选中第一个
          setChooseCustomerId(res.list[0].customerId);
          setChooseTrackPlanId(res.list[0].id);
          // 为了触发计划改派和其他tab的重新拉取逻辑
          if (tabsChoose === '5') {
            setSalesTemplateId(res.list[0].salesTemplateId);
          } else {
            setSalesTemplateId('')
          }
        } else {
          setChooseCustomerId('');
          setChooseTrackPlanId('');
          setSalesTemplateId('')
        }
        setUserData(res?.list);
      }
      if (noAutoChoose) {
        let chooseFlag = false;
        res?.list.forEach(item => {
          if (item.id === chooseTrackPlanId) {
            item.choose = true
            chooseFlag = true;
          }
        })
        /**
         * 处理变更服务人员和提交无效，销售计划从登录人列表移除的情况
         */
        if (!chooseFlag) {
          setChooseCustomerId('');
          setChooseTrackPlanId('');
          setSalesTemplateId('')
        } else {
          // 还存在就重新拉服务人员
          fetchTrackPlanRelatives(chooseTrackPlanId);
        }
        setUserData(res?.list);
      }
    } catch (err) {
      setLoading(false);
      console.log(err)
      message.error('查询列表失败');
    }
  }

  // 客户标签
  const fetchTagTreeByType = async () => {
    try {
      const res: any = await getTagTreeByType('custom');
      if (res?.records) {
        const tagList: any = [];
        res?.records?.forEach(item => {
          // 一级分类
          if (item?.children && item?.children?.length) {
            // 二级分类
            item?.children.forEach(item2 => {
              if (item2?.children && item2?.children?.length) {
                // 三级标签
                tagList.push({
                  key: item2?.id,
                  title: item2?.label,
                  tags: item2?.children?.map(tag => ({ description: tag?.label, key: tag?.id }))
                })
              }
            })
          }
        });
        setTagList(tagList);
      }
    } catch (err) {
      console.log(err);
    }
  }

  // 流程
  const fetchTrackPlanNode = async (trackPlanId: any) => {
    try {
      const res: any = await getTrackPlanNode({trackPlanId});
      if (res) {
        setTrackPlanNodeData(res);
      }
    } catch (err) {
      console.log(err);
    }
  }

  // 客户信息
  const fetchCustomerMemberInfo = async (customerId: any) => {
    try {
      setLoading(true);
      const res: any = await getCustomerMemberInfo(customerId) || {};
      if (res) {
        setCustomerInfo(res);
      }
      setLoading(false);
    } catch (err) {
      setLoading(false);
      console.log(err);
    }
  }

  // 基础信息
  const fetchTrackPlanInfo = async (trackPlanId: any) => {
    try {
      setLoading(true);
      const res: any = await getTrackPlanInfo(trackPlanId) || {};
      if (res) {
        setTrackPlanInfo(res);
      }
      setLoading(false);
    } catch (err) {
      setLoading(false);
      console.log(err);
    }
  }

  // 看板数据
  const fetchTrackDetailCount = async (trackPlanId: any) => {
    try {
      setLoading(true);
      const res: any = await getTrackDetailCount({ trackPlanId });
      if (res) {
        setDetailCountData(res);
      }
      setLoading(false);
    } catch (err) {
      setLoading(false);
      console.log(err);
    }
  }

  // 服务人员
  const fetchTrackPlanRelatives = async (trackPlanId: any) => {
    try {
      const res: any = await getTrackPlanRelatives({ trackPlanId });
      if (res) {
        setTrackPlanReletiveInfo(res);
      }
    } catch (err) {
      console.log(err);
    }
  }

  // 跟进记录
  const fetchTrackPlanLog = async (trackPlanId: any) => {
    try {
      const res: any = await getTrackPlanLog({ trackPlanId });
      if (res) {
        setTrackPlanLogInfo(res);
      }
    } catch (err) {
      console.log(err);
    }
  }

  // 各个tab的人员数字
  const fetchTabCount = async () => {
    try {
      const res: any = await getTabPageCount({});
      if (res) {
        setTabCountData(res);
      }
    } catch (err) {
      console.log(err);
    }
  }

  // 画像标签
  const fetchDrawTags = async (trackPlanId: string) => {
    try {
      const res: any = await getDrawTags(trackPlanId);
      if (res) {
        const map: any = {};
        res.forEach(item => {
          if (item?.type === 'customer') {
            map['customer'] = item?.tags?.map(tag => ({ key: tag?.tagId, name: tag?.tagName, id: tag?.id }));
          }
          if (item?.type === 'track') {
            map['track'] = item?.tags?.map(tag => ({ key: tag?.tagId, name: tag?.tagName, id: tag?.id }));
          }
        })
        setDrawTagListMap(map);
      }
    } catch (err) {
      console.log(err);
    }
  }

  const handleChangePage = async (pageId: number) => {
    setPageId(pageId)
  }

  const handleChooseCustomer = async (item: any) => {
    const newData: any = userData.map((user: any) => {
      if (user.id === item.id) {
        return {
          ...user,
          choose: true,
        }
      }
      return {
        ...user,
        choose: false,
      }
    })
    setUserData(newData);
    setChooseCustomerId(item.customerId);
    setChooseTrackPlanId(item.id);
    setSalesTemplateId(item.salesTemplateId)
  }

  const onTabsChange = async (key: string) => {
    console.log(key);
    setTabsChoose(key);
    setSearchData({});
    setPageId(1);
  };
  
  const booleanOptions = [
    { value: true, label: '是' },
    { value: false, label: '否' },
  ];

  const onFinish = (data: any) => {
    setPageId(1);
    setSearchData({...data})
  }

  const onReset = () => {
    setPageId(1);
    setSearchData({});
    fetchTabCount()
  }

  const onDel = () => {
    console.log(customerInfo)
    SMessage.confirm({
      title: '删除销售计划之后不可恢复，请慎重删除。',
      content: null,
      onOk: () => {
        return new Promise(resolve => resolve)
      }
    })
  }

  const buttonList = () => {
    return (
      <>
        <Button
          type='primary'
          onClick={onDel}
          style={{ marginRight: 15 }}
        >
          删除销售计划
        </Button>
        <Button
          type='primary'
          icon={<PlusOutlined />}
          ghost
          style={{ marginRight: 15 }}
          onClick={handleAddNewPlan}
        >
          新增
        </Button>
      </>
    )
  }

  const handleAddNewPlan = () => {
    setIsEdit(false);
    setOpenAddModal(true);
  }

  const handleEditBasicInfo = () => {
    setIsEdit(true);
    setOpenAddModal(true);
  }

  const handleEditCustomerInfo = () => {
    setOpenCustomerModal(true);
  }

  const handleSeeCustomerInfo = () => {
    setOpenCustomerDetail(true)
  }

  const handleChooseTagModal = () => {
    setOpenChooseTagModal(true);
  }

  const treeRender = (key) => {
    return (
      <TreeSelect key={key} placeholder="请选择" allowClear={true} treeData={dictionaryData?.treeList}/>
    )
  }

  const userContent = (item) => {
    return (
      <div
        className={styles.userBox}
        style={{
          backgroundColor: item.choose ? 'rgba(240, 246, 255, 1)' : '#fff',
          boxShadow: item.choose ? 'transparen' : '0px 1px 2px 0px rgba(45, 45, 46, 0.2)',
          border: item.choose ? '1px solid rgba(0, 100, 255, 1)' : '1px solid transparent',
        }}
        onClick={() => handleChooseCustomer(item)}
      >
        <Checkbox onClick={e => e.stopPropagation()} onChange={(e) => clickRole(e, item)}>
        </Checkbox>
        <div
          className={styles.userContent}
        >
          <div className={styles.userImgBox}>
            <img className={styles.userImg} src={avatarNew} />
          </div>
          <div>
            <div className={styles.userInfoBox}>
              <div className={styles.userName}>
                { item.name }
              </div>
              <div className={styles.userId}>
                { item.id }
              </div>
            </div>
            <div className={styles.userInfoBox}>
              <div className={styles.userNumber}>{ item.showPhoneNumber ? item.truePhone : item.phone }</div>
              {
                authDict?.['salePlanViewPhone'] ? (
                  <div className={styles.phoneNumberIcon} onClick={(e) => handleShowPhoneNumber(item, e)}>
                    {
                      item.showPhoneNumber ? <EyeOutlined style={{ fontSize: '16px' }} /> : <EyeInvisibleOutlined style={{ fontSize: '16px' }} />
                    }
                  </div>
                ) : null
              }
            </div>
            <div className={styles.userRecordBox}>
              <div className={styles.fontColorA}>最后跟进：</div>
              <div className={styles.fontColorB}>{ item.lastFollowTime ? dayjs(item.lastFollowTime).format('YYYY-MM-DD HH:mm') : '' }</div>
            </div>
          </div>
          <div className={styles.userTagBox}>
            { item.statusName }
          </div>
        </div>
      </div>
    )
  }

  const clickRole = (e, item) => {
    e.stopPropagation();
    console.log(e, item)
  }

  const handleShowPhoneNumber = async (item: any, e: any) => {
    e.stopPropagation();
    if (item.truePhone) {
      const newData = userData.map((user: any) => {
        if (item.id === user.id) {
          return {
            ...user,
            showPhoneNumber: !user.showPhoneNumber,
          }
        }
        return {
          ...user,
        }
      });
      setUserData(newData);
    } else {
      const res = await viewPhone(item.id)
      const newData = userData.map((user: any) => {
        if (item.id === user.id) {
          return {
            ...user,
            showPhoneNumber: !user.showPhoneNumber,
            truePhone: res
          }
        }
        return {
          ...user,
        }
      });
      setUserData(newData);
    }
  }

  const changeInfoChoice = (event: any) => {
    if (event?.target?.value === 'b') {
      fetchTrackPlanLog(chooseTrackPlanId);
    }
    setInfoChoice(event?.target?.value);
  }

  const handleAddNewFollow = (buttonKey: string) => {
    setChooseButtonKey(buttonKey);
    setOpenNewFollowModal(true);
  }

  const handleSubmitPending = (buttonKey: string) => {
    setChooseButtonKey(buttonKey);
    setOpenSubmitPendingModal(true);
  }

  const handleSubmitEffective = (buttonKey: string) => {
    setChooseButtonKey(buttonKey);
    setOpenSubmitEffectiveModal(true);
  }

  const handleSubscribe = (buttonKey: string) => {
    setChooseButtonKey(buttonKey);
    setOpenSubscribeModal(true);
  }

  const handleConfirm = (buttonKey: string) => {
    setChooseButtonKey(buttonKey);
    setOpenConfirmModal(true);
  }

  const handleSubmitInvalid = (buttonKey: string) => {
    setChooseButtonKey(buttonKey);
    setOpenSubmitInvalidModal(true);
  }

  const handleopenAllowcateModal = (buttonKey) => {
    setExtraPopoverOpen(false);
    const otherBtn = {
      CHANGE_TIME : () => setOpenChangeDeliveryTimeModal(true),
      DELAY : () => setOpenDelayReassignModal(true),
      GO_CASE : () => setOpenProposalMasterModal(true),
      GO_DESIGNER : () => setOpenDesignMasterModal(true),
    }
    if(otherBtn[buttonKey]){
      otherBtn[buttonKey]()
    } else {
      setChooseButtonKey(buttonKey)
      setOpenAllowcateModal(true);
    }
  }

  const buttonKeyToFuncMap = {
    'ADD_RECORD': () => handleAddNewFollow('ADD_RECORD'),
    'SUBMIT_PENDING': () => handleSubmitPending('SUBMIT_PENDING'),
    'SUBMIT_VALID': () => handleSubmitEffective('SUBMIT_VALID'),
    'SUBMIT_INVALID': () => handleSubmitInvalid('SUBMIT_INVALID'),
    'APPOINTMENT_STORE': () => handleSubscribe('APPOINTMENT_STORE'),
    'CONFIRM_TO_SHOP': () => handleConfirm('CONFIRM_TO_SHOP'),
  }

  const popButtonContent = () => {
    return (
      <div style={{ display: 'flex', flexDirection: 'column' }}>
        {
          extraButtonList?.length !== 0 && extraButtonList?.map((button: any) => (
            <Button onClick={() => handleopenAllowcateModal(button?.buttonKey)} type='primary' ghost style={{ marginTop: 15, width: 150 }}>{ button?.buttonDesc }</Button>
          ))
        }
      </div>
    )
  }

  const reloadPage = async (trackPlanId) => {
    await fetchList({ pageId, values: searchData }, true)
    await fetchTrackPlanInfo(trackPlanId);
    fetchTrackDetailCount(trackPlanId);
    fetchTrackPlanLog(trackPlanId);
    fetchTrackPlanRelatives(trackPlanId);
    fetchDrawTags(trackPlanId);
    fetchTrackPlanNode(trackPlanId);
    fetchButtonList(trackPlanId);
    fetchCustomerMemberInfo(chooseCustomerId)
    fetchTabCount();
  }

  const closePage = async () => {
    await fetchList({ pageId, values: searchData }, true);
    fetchTabCount();
  }

  const handleTabs = () => {
    const basicTabs = [
      {
        label: `全部${(tabCountData as any)?.all ? `（${(tabCountData as any)?.all}）` : ''}`,
        key: '1',
      },
      {
        label: `新分配${(tabCountData as any)?.recentDispatchNum ? `（${(tabCountData as any)?.recentDispatchNum}）` : ''}`,
        key: '2',
      },
      {
        label: `最近沟通${(tabCountData as any)?.recentFollowNum ? `（${(tabCountData as any)?.recentFollowNum}）` : ''}`,
        key: '3',
      },
      {
        label: `待分配${(tabCountData as any)?.pendingDispatchNum ? `（${(tabCountData as any)?.pendingDispatchNum}）` : ''}`,
        key: '4',
      },
    ];
    if (authDict?.['salesPlan2']) {
      basicTabs.push({
        label: '计划改派',
        key: '5',
      });
    }
    return basicTabs;
  }

  return (
    <div className={styles.sellPlanBox}>
      <Spin spinning={loading}>
        <div className={styles.sellPlan}>
          <Tabs
            style={{ paddingLeft: '10px', backgroundColor: 'white' }}
            defaultActiveKey="1"
            onChange={onTabsChange}
            items={handleTabs()}
          />
          <div
            className={styles.searchBox}
          >
            <SSearchForm
              {...config}
              formRef={listRef}
              searchMode="group"
              fieldControl={false}
              options={{ booleanOptions, ...dictionaryData }}
              events={{ handleOrgChange }}
              onFinish={onFinish}
              onReset={onReset}
              renderOperations={buttonList}
            >
            </SSearchForm>
          </div>
          <div
            className={styles.listBox}
          >
            <div className={styles.listContent}>
              <List
                style={{ height: '100%', position: 'static' }}
                itemLayout="vertical"
                size="large"
                pagination={{
                  onChange: handleChangePage,
                  pageSize: 10,
                  size: 'small',
                  showQuickJumper: (totalNumber / 10) > 100 ? false :  true,
                  showSizeChanger: false,
                  total: totalNumber,
                  current: pageId,
                }}
                dataSource={userData}
                renderItem={(item: any) => (
                  <List.Item
                    key={item.title}
                  >
                    {userContent(item)}
                  </List.Item>
                )}
              />
            </div>
            { chooseTrackPlanId ? <div className={styles.customerBox}>
              <div className={styles.customerContent}>
                <div className={styles.customerButton}>
                  <div className={styles.actionButtonBox}>
                    <STitle title='客户信息' />
                    <div className={styles.actionButtons}>
                      {
                        mainButtonList?.length !== 0 ? mainButtonList?.map((button: any) => (
                          <Button
                            type='primary'
                            ghost={button?.buttonKey === 'ADD_RECORD' ? false :  true}
                            style={{
                              marginLeft: 10,
                              padding: '4px 10px',
                              fontSize: '12px',
                              lineHeight: '20px',
                              height: '30px'
                            }}
                            onClick={buttonKeyToFuncMap[button?.buttonKey]}
                          >
                            { button?.buttonDesc }
                          </Button>
                        )) : null
                      }
                      {
                        extraButtonList?.length !== 0 ? (
                          <Popover content={popButtonContent()}
                                   trigger="hover"
                                   onOpenChange={(open) => setExtraPopoverOpen(open)}
                                   open={extraPopoverOpen}
                                   title={null}
                                   placement={'bottom'}>
                            <Button
                              icon={<UnorderedListOutlined />}
                              style={{
                                marginLeft: 10,
                                width: '30px',
                                height: '30px'
                              }}
                            >
                            </Button>
                          </Popover>
                        ) : null
                      }
                    </div>
                  </div>
                </div>
                <WorkProcess basicInfo={trackPlanNodeData} />
                <OperationBoard detailData={detailCountData} />
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: 20 }}>
                  <Radio.Group defaultValue={ infoChoice } buttonStyle="solid" onChange={changeInfoChoice}>
                    <Radio.Button value="a">基本信息</Radio.Button>
                    <Radio.Button value="b">跟进记录</Radio.Button>
                    <Radio.Button value="c">服务人员</Radio.Button>
                    <Radio.Button value="d">订单信息</Radio.Button>
                  </Radio.Group>
                  {
                    infoChoice === 'a' && (
                      <Button
                        type='primary'
                        ghost
                        style={{
                          marginLeft: 10,
                          padding: '4px 10px',
                          fontSize: '12px',
                          lineHeight: '20px',
                          height: '30px'
                        }}
                        onClick={handleEditBasicInfo}
                      >
                        编辑基本信息
                      </Button>
                    )
                  }
                </div>
                {
                  infoChoice === 'a' && (
                    <BasicInfo reload={onReset} basicInfo={trackPlanInfo} editTag={true} />
                  )
                }
                {
                  infoChoice === 'b' && (
                    <FollowRecord basicInfo={trackPlanLogInfo} />
                  )
                }
                {
                  infoChoice === 'c' && (
                    <ServiorInfo
                      tab={tabsChoose}
                      buttonKeyList={extraButtonList?.map((button: any) => button?.buttonKey) || []}
                      reload={() => closePage()}
                      editId={chooseTrackPlanId}
                      basicInfo={trackPlanReletiveInfo}
                      orgId={trackPlanInfo?.houseInfo?.orgId}
                    />
                  )
                }
                {
                  infoChoice === 'd' && (
                    <OrderInfo editId={chooseTrackPlanId} />
                  )
                }
              </div>
              <div className={styles.extraInfo}>
                <div className={styles.extraItemBox}>
                  <div className={styles.titleBox}>
                    <div className={styles.title}>客户信息</div>
                    <div onClick={handleEditCustomerInfo} className={styles.operation}>编辑</div>
                  </div>
                  <div className={styles.titleFont}><span className={styles.fontColorA}>性别：</span><span className={styles.fontColorB}>{ (customerInfo?.customerInfo as any)?.gender || '' }</span></div>
                  <div className={styles.titleFont}><span className={styles.fontColorA}>年龄：</span><span className={styles.fontColorB}>{ (customerInfo?.customerInfo as any)?.age || '' }</span></div>
                  <div onClick={handleSeeCustomerInfo} className={styles.seeMore}>查看更多</div>
                </div>
                <div className={styles.extraItemBox} style={{ maxHeight: 250, overflow: 'scroll' }}>
                  <div className={styles.titleBox}>
                    <div className={styles.title}>画像</div>
                  </div>
                  <div className={styles.tagBox}>
                    <div className={styles.tagTitle}>内容标签：</div>
                    <div className={styles.tagContent}>
                      {
                        (drawTagListMap as any)?.['customer']?.map((tag, index) => (
                          <div className={styles.tag} style={{ border: `1px solid ${colorList[index % 4]?.borderColor}`, color: colorList[index % 4]?.fontColor }}>{ tag?.name }</div>
                        ))
                      }
                    </div>
                  </div>
                  <div className={styles.tagBox}>
                    <div className={styles.editTitleBox}>
                      <div className={styles.tagTitle}>销售计划：</div>
                      <div onClick={handleChooseTagModal} className={styles.operation}>编辑标签</div>
                    </div>
                    <div className={styles.tagContent}>
                      {
                        (drawTagListMap as any)?.['track']?.map((tag, index) => (
                          <div className={styles.tag} style={{ border: `1px solid ${colorList[index % 4]?.borderColor}`, color: colorList[index % 4]?.fontColor }}>{ tag?.name }</div>
                        ))
                      }
                    </div>
                  </div>
                </div>
                
                  <div className={styles.extraItemBox} style={{ borderBottom: 'none'}}>
                    <div className={styles.titleBox}>
                      <div className={styles.title}>行为数据</div>
                    </div>
                    <div>暂无</div>
                    {/**
                      <div style={{ height: '194px', backgroundColor: 'rgba(135, 136, 138, 1)', marginBottom: '5px' }}></div>
                      <div className={styles.seeMore}>查看更多</div>
                     */}
                  </div>
              </div>
            </div> : (<div></div>)}
          </div>
        </div>
      </Spin>
      {/** 新增计划和编辑基础信息弹窗 */}
      { openAddModal && <AddNewPlanModal basicInfo={trackPlanInfo} editReload={() => reloadPage(chooseTrackPlanId)} reload={onReset} isEdit={isEdit} open={openAddModal} onClose={() => setOpenAddModal(false)} /> }
      {/** 编辑客户信息弹窗 */}
      { openCustomerModal && <CustomerModal reload={() => reloadPage(chooseTrackPlanId)} editId={chooseCustomerId} open={openCustomerModal} customerInfo={customerInfo} onClose={() => setOpenCustomerModal(false)} /> }
      {/** 查看客户信息 */}
      { openCustomerDetail && <CustomerDetail open={openCustomerDetail} customerInfo={customerInfo} onClose={() => setOpenCustomerDetail(false)} />}
      {/** 标签弹窗 */}
      { openChooseTagModal && <ChooseTagModal single={true} reload={() => fetchDrawTags(chooseTrackPlanId)} tagList={drawTagListMap?.['track'] || []} list={(tagList as any)} editId={chooseTrackPlanId} open={openChooseTagModal} onClose={() => setOpenChooseTagModal(false)} /> }
      {/** 新增跟进弹窗 */}
      { openNewFollowModal && <AddNewFollowModal buttonKey={chooseButtonKey} reload={() => reloadPage(chooseTrackPlanId)} editId={chooseTrackPlanId} open={openNewFollowModal} onClose={() => setOpenNewFollowModal(false)} />}
      {/** 提交待定弹窗 */}
      { openSubmitPendingModal && <SubmitPendingModal buttonKey={chooseButtonKey} reload={() => reloadPage(chooseTrackPlanId)} editId={chooseTrackPlanId} open={openSubmitPendingModal} onClose={() => setOpenSubmitPendingModal(false)} />}
      {/** 提交有效弹窗 */}
      { openSubmitEffectiveModal && <SubmitEffectiveModal basicInfo={trackPlanInfo} buttonKey={chooseButtonKey} reload={() => reloadPage(chooseTrackPlanId)} editId={chooseTrackPlanId} open={openSubmitEffectiveModal} onClose={() => setOpenSubmitEffectiveModal(false)} />}
      {/** 预约到店弹窗 */}
      { openSubscribeModal && <SubscribeModal basicInfo={trackPlanInfo} buttonKey={chooseButtonKey} reload={() => reloadPage(chooseTrackPlanId)} editId={chooseTrackPlanId} open={openSubscribeModal} onClose={() => setOpenSubscribeModal(false)} />}
      {/** 确认到店弹窗 */}
      { openConfirmModal && <ConfirmModal basicInfo={trackPlanInfo} buttonKey={chooseButtonKey} reload={() => reloadPage(chooseTrackPlanId)} editId={chooseTrackPlanId} open={openConfirmModal} onClose={() => setOpenConfirmModal(false)} />}
      {/** 提交无效弹窗 */}
      { openSubmitInvalidModal && <SubmitInvalidModal buttonKey={chooseButtonKey} reload={() => closePage()} editId={chooseTrackPlanId} open={openSubmitInvalidModal} onClose={() => setOpenSubmitInvalidModal(false)} />}
      {/** 分配服务人员弹窗 */}
      { openAllowcateModal && <AllowcateWorkerModal orgId={trackPlanInfo?.houseInfo?.orgId} tab={tabsChoose} buttonKey={chooseButtonKey} reload={() => reloadPage(chooseTrackPlanId)} editId={chooseTrackPlanId} open={openAllowcateModal} onClose={() => setOpenAllowcateModal(false)} />}
      {/** 变更交房时间弹窗 */}
      { openChangeDeliveryTimeModal && <ChangeDeliveryTimeModal orgId={trackPlanInfo?.houseInfo?.orgId} reload={() => reloadPage(chooseTrackPlanId)} editId={chooseTrackPlanId} open={openChangeDeliveryTimeModal} onClose={() => setOpenChangeDeliveryTimeModal(false)} />}
      {/** 延期改派弹窗 */}
      { openDelayReassignModal && <DelayReassignModal orgId={trackPlanInfo?.houseInfo?.orgId} reload={() => reloadPage(chooseTrackPlanId)} editId={chooseTrackPlanId} open={openDelayReassignModal} onClose={() => setOpenDelayReassignModal(false)} />}
      {/** 去提案大师弹窗 */}
      { openProposalMasterModal && <ProposalMasterModal orgId={trackPlanInfo?.houseInfo?.orgId} reload={() => reloadPage(chooseTrackPlanId)} editId={chooseTrackPlanId} open={openProposalMasterModal} onClose={() => setOpenProposalMasterModal(false)} />}
      {/** 去设计大师弹窗 */}
      { openDesignMasterModal && <DesignMasterModal orgId={trackPlanInfo?.houseInfo?.orgId} reload={() => reloadPage(chooseTrackPlanId)} editId={chooseTrackPlanId} open={openDesignMasterModal} onClose={() => setOpenDesignMasterModal(false)} />}
    </div>
  )
}